// ** React Imports

import { useState, useEffect, SyntheticEvent, ChangeEvent } from 'react'



import appInfo from '../../../../configs/app-info';



import Box from '@mui/material/Box'

import Card from '@mui/material/Card'

import CardHeader from '@mui/material/CardHeader'

import Button from '@mui/material/Button'

import Typography from '@mui/material/Typography'

import CardContent from '@mui/material/CardContent'

import Grid, { GridProps } from '@mui/material/Grid';

import { styled, useTheme } from '@mui/material/styles'

import FormControl from '@mui/material/FormControl'

import TextField from '@mui/material/TextField'

import FormHelperText from '@mui/material/FormHelperText'

import CircularProgress from '@mui/material/CircularProgress'

import FormLabel from '@mui/material/FormLabel'

import {

    CardActions,

    Divider,

    IconButton,

    InputAdornment,

    Radio,

    RadioGroup,

    Tooltip,

    Fab,

    FormControlLabel,

    Checkbox,

    OutlinedInput,

    Rating,

    Autocomplete,

    TableCell,

    FormGroup

} from '@mui/material'



import Select, { SelectChangeEvent } from '@mui/material/Select'

import MenuItem from '@mui/material/MenuItem'

import InputLabel from '@mui/material/InputLabel'



import Table from '@mui/material/Table'

import TableRow from '@mui/material/TableRow'

import TableHead from '@mui/material/TableHead'

import TableBody from '@mui/material/TableBody'

import TableContainer from '@mui/material/TableContainer'



import Dialog from '@mui/material/Dialog'

import DialogTitle from '@mui/material/DialogTitle'

import DialogContent from '@mui/material/DialogContent'

import DialogContentText from '@mui/material/DialogContentText'

import DialogActions from '@mui/material/DialogActions'



import { useNavigate, useParams } from "react-router-dom";

import { Controller, useForm } from 'react-hook-form'

import axios from 'axios'

import Swal from 'sweetalert2'



import Icon from '../../../../components/icon';

import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';

import apiUrl from '../../../../configs/constant';

import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';

import MsiDatagridAutoPlain from '../../../../components/custom/MsiDatagridAutoPlain';

import moment from 'moment';

import React from 'react';

import AttachmentFab from '../../../../components/attachment/AttachmentFab';

import FloatingJurnalButton from '../../../../components/acc/jurnal/FabJurnal';





const tableFixHead = { position: 'sticky', top: 0, zIndex: 3 }

const styleCell = {

    textAlign: 'center',

    border: '0.5px solid rgba(0, 0, 0, 0.12)'

}

const styleCellInput = {

    width: 120,

    textAlign: 'center',

    border: '0.5px solid rgba(0, 0, 0, 0.12)'

}

const titleHeader = {

    textTransform: 'none',

    color: '#212121',

    textAlign: 'center',

    fontWeight: 600,

    fontSize: 15

}

const contentPrimary = {

    color: '#212121',

    textAlign: 'center',

    fontWeight: 400,

    fontSize: 15

}

const contentPrimaryInfo = {

    color: '#4472C4',

    textAlign: 'center',

    fontWeight: 500,

    fontSize: 15

}



const checkExtension = (fileName: any) => {

    const extension = fileName.substring(fileName.lastIndexOf('.') + 1)



    return extension

}



const tampilkanGambar = (url: string) => {

    if (

        url != '' &&

        url !=

        'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'

    ) {

        Swal.fire({

            imageUrl: url,

            imageAlt: 'Gambar'

        })

    } else {

        Swal.fire({

            icon: 'warning',

            title: 'Pemberitahuan',

            text: 'Gambar Tidak Tersedia'

        })

    }

}



export default function Detail() {

    const userData = JSON.parse(localStorage.getItem('user')!)

    const user = userData.data

    const token = userData.token



    const cabang = JSON.parse(localStorage.getItem('cabang')!)



    const { id } = useParams();



    // ** State

    const [listDetail, setListDetail] = useState<any[]>([])



    const [isOto, setIsOto] = useState<any>(null)

    const [isAktif, setIsAktif] = useState<any>(null)

    const [otNow, setOtNow] = useState<any>(null)



    const [modeSave, setModeSave] = useState<any>(null)

    const [openDialog, setOpenDialog] = useState(false)

    const [idD, setIdD] = useState<any>(null)

    const [qty, setQty] = useState<any>(null)

    const [editQty, setEditQty] = useState<any>(null)



    // ** State

    const [valDoctag, setValDoctag] = useState<any>(null)

    const [listDoctag, setListDoctag] = useState<any[]>([])



    const [valGudang, setValGudang] = useState<any>(null)

    const [listGudang, setListGudang] = useState<any[]>([])



    const [valSubgudang, setValSubgudang] = useState<any>(null)

    const [listSubgudang, setListSubgudang] = useState<any[]>([])



    const handleOpenDialog = (row: any) => {

        const data = row.data



        setIdD(data.pbgr_d_id)

        const currentQty = Number(data.qty_datang ?? data.qty_doc ?? data.qty ?? 0)

        setQty(currentQty)
        setEditQty(currentQty)
        setOpenDialog(true)

    }



    const handleCloseDialog = () => {

        setOpenDialog(false)

    }



    useEffect(() => {

        getDetail()

        getData()

    }, [])



    const getDetail = () => {

        const url = apiUrl.apiUrl + '/purchasing/gr/detail-gr'

        axios

            .get(url, {

                params: { pbgr_id: id },

                headers: { Authorization: `Bearer ${token}` }

            })

            .then(response => {

                if (response.data.success) {

                    const data = response.data.data[0]

                    const detail = response.data.detail.map((row: any, index: any) => ({

                        ...row,

                        id: index + 1

                    }));

                    setListDetail(detail)

                } else {

                    Swal.fire({

                        title: 'Pemberitahuan',

                        text: response.data.message,

                        icon: 'error'

                    })

                }

            })

    }





    const getCheckGR = () => {

        const url = apiUrl.apiUrl + '/purchasing/gr/get-cek-data-gr/' + id

        axios

            .get(url, {

                params: {},

                headers: { Authorization: `Bearer ${token}` }

            })

            .then(response => {

                if (response.data.success) {

                    const data = response.data.data[0]

                    setOtNow(data?.ot_now)

                    setIsAktif(data?.is_aktif)



                    Swal.close()

                } else {

                    Swal.fire({

                        title: 'Pemberitahuan',

                        text: response.data.message,

                        icon: 'error'

                    })

                }

            })

    }



    const navigate = useNavigate();



    interface FormInputs {

        pbpr_d_id: any



        syscabang_id: any

        sysdoctag_id: any

        pbsupplier_id: any

        sysmatauang_id: any

        pbpo_id: any

        pbpo_d_id: any

        mmgudang_id: any

        mmgudang_sub_id: any

        barang: any

        qty: any

        tgl: any

        tgl_kirim: any

        transportasi: any

        harga: any

        nomor_timbang: any

        mmbarang_id: any

        nomor_sj: any

        kurir: any

        pic: any

        keterangan: any

        nama_vendor: any

        sisa_qty: any

        total: any

    }



    const defaultValues = {

        pbpr_d_id: id,

        keterangan: ''

    }



    const {

        control,

        handleSubmit,

        setValue,

        getValues,

        formState: { errors }

    } = useForm<FormInputs>({ defaultValues })



    const onSubmit = (data: any) => {

        Swal.fire({

            title: 'Konfirmasi',

            text: 'Apakah anda ingin menyimpan data ini ?',

            icon: 'question',

            showCancelButton: true,

            confirmButtonColor: '#337ab7',

            cancelButtonColor: '#ffc107',

            confirmButtonText: 'Simpan'

        }).then(result => {

            if (result.isConfirmed) {

                Swal.fire({

                    title: 'Now loading',

                    allowEscapeKey: false,

                    allowOutsideClick: false,

                    didOpen: () => {

                        Swal.showLoading()

                    }

                })



                let url = apiUrl.apiUrl + '/purchasing/gr/edit/' + id

                axios

                    .post(url, data, {

                        headers: { Authorization: `Bearer ${token}` }

                    })

                    .then(response => {

                        if (response.data.success) {

                            Swal.fire({

                                title: 'Pemberitahuan',

                                text: response.data.message,

                                icon: 'success',

                                timer: 1000,

                                timerProgressBar: true,

                                willClose: () => {

                                    const id = response.data.data

                                    navigate('/purchasing/purchase-order')

                                }

                            })

                        } else {

                            Swal.fire({

                                title: 'Pemberitahuan',

                                text: response.data.message,

                                icon: 'error'

                            })

                        }

                    })

                    .catch(error => {

                        Swal.fire({

                            title: 'Pemberitahuan',

                            text: error.message,

                            icon: 'error'

                        })

                    })

            }

        })

    }



    const getDoctag = (ids: any) => {

        const url = apiUrl.apiUrl + '/system/doctag/list-combo'

        axios

            .get(url, {

                params: {

                    syscabang_id: cabang,

                    sysmenu_id: 40

                },

                headers: { Authorization: `Bearer ${token}` }

            })

            .then(response => {

                if (response.data.success) {

                    const data = response.data.data

                    data.forEach((element: any) => {

                        if (element.id == ids) {

                            setValDoctag(element)

                        }

                    });

                    setListDoctag(data)

                } else {

                    Swal.fire({

                        title: 'Pemberitahuan',

                        text: response.data.message,

                        icon: 'error'

                    })

                }

            })



    }



    const getGudang = (ids: any) => {

        const url = apiUrl.apiUrl + '/mm/gudang/list-combo'

        axios

            .get(url, {

                params: {},

                headers: { Authorization: `Bearer ${token}` }

            })

            .then(response => {

                if (response.data.success) {

                    const data = response.data.data



                    data.forEach((element: any) => {

                        if (element.id == ids) {

                            setValGudang(element)

                        }

                    });

                    setListGudang(data)

                } else {

                    Swal.fire({

                        title: 'Pemberitahuan',

                        text: response.data.message,

                        icon: 'error'

                    })

                }

            })



    }



    const getSubGudang = (ids: any) => {

        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'

        axios

            .get(url, {

                params: {},

                headers: { Authorization: `Bearer ${token}` }

            })

            .then(response => {

                if (response.data.success) {

                    const data = response.data.data



                    data.forEach((element: any) => {

                        if (element.id == ids) {

                            setValSubgudang(element)

                        }

                    });

                    setListSubgudang(data)

                } else {

                    Swal.fire({

                        title: 'Pemberitahuan',

                        text: response.data.message,

                        icon: 'error'

                    })

                }

            })



    }



    const getData = () => {

        Swal.fire({

            title: 'Now loading',

            allowEscapeKey: false,

            allowOutsideClick: false,

            didOpen: () => {

                Swal.showLoading()

            }

        })



        const url = apiUrl.apiUrl + '/purchasing/gr/detail/' + id

        axios

            .get(url, {

                params: { mode: 1 },

                headers: { Authorization: `Bearer ${token}` }

            })

            .then(response => {

                if (response.data.success) {

                    const data = response.data.data[0]

                    setValue('tgl', data.tgl?.substring(0, 10))

                    setValue('pbpo_id', data.pbpo_id)

                    setValue('nama_vendor', data.nama_vendor)

                    setValue('nama_vendor', data.nama_vendor)

                    setValue('barang', data.nama_barang)

                    setValue('qty', data.qty)

                    setValue('harga', data.harga)

                    setValue('total', data.total)

                    setValue('sisa_qty', data.sisa_qty)

                    setValue('pbpo_d_id', data.pbpo_d_id)

                    setValue('pbsupplier_id', data.pbsupplier_id)

                    setValue('mmbarang_id', data.mmbarang_id)

                    setValue('kurir', data.kurir)

                    setValue('transportasi', data.transportasi)

                    setValue('tgl_kirim', data.tgl_kirim?.substring(0, 10))

                    setValue('nomor_sj', data.nomor_sj)

                    setValue('keterangan', data.keterangan)

                    setValue('sysdoctag_id', data.sysdoctag_id)

                    setValue('mmgudang_id', data.mmgudang_id)

                    setValue('mmgudang_sub_id', data.mmgudang_sub_id)



                    getDoctag(data.sysdoctag_id)

                    getGudang(data.mmgudang_id)

                    getSubGudang(data.mmgudang_sub_id)
                    getCheckGR()

                    Swal.close()

                } else {

                    Swal.fire({

                        title: 'Pemberitahuan',

                        text: response.data.message,

                        icon: 'error'

                    })

                }

            })



    }



    const handleSaveQty = () => {
        const qtyBaru = Number(editQty)

        if (!Number.isFinite(qtyBaru) || qtyBaru <= 0) {
            Swal.fire({
                title: 'Pemberitahuan',
                text: 'Qty baru harus lebih besar dari 0.',
                icon: 'warning'
            })
            return
        }

        Swal.fire({
            title: 'Konfirmasi',
            text: `Ubah qty dari ${qty} menjadi ${qtyBaru}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Ya, Ubah',
            cancelButtonText: 'Batal'
        }).then(result => {
            if (!result.isConfirmed) return

            const data = {
                pbgr_id: Number(id),
                pbgr_d_id: Number(idD),
                qty_baru: qtyBaru
            }

            const url = apiUrl.apiUrl + '/purchasing/gr/edit-qty'

            axios.post(url, data, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(response => {
                if (response.data.success) {
                    setOpenDialog(false)
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'success',
                        timer: 1000,
                        timerProgressBar: true,
                        willClose: () => {
                            getDetail()
                            getData()
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            }).catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error?.response?.data?.message || error.message || 'Gagal mengubah qty GR.',
                    icon: 'error'
                })
            })
        })
    }



    const customRender = [

        {

            key: "qty_datang",

            renderCell: (row: any) => (

                <Typography variant='body2' sx={{ fontWeight: 400 }}>

                    {row.value}

                    <IconButton color='primary' onClick={() => handleOpenDialog(row)}>

                        <Icon icon='mdi:pencil' fontSize={20} />

                    </IconButton>

                </Typography>

            ),

        },

    ];



    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {

        setValue('sysdoctag_id', newValue?.id)

        setValDoctag(newValue)

    }



    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {

        setValue('mmgudang_id', newValue?.id)

        setValGudang(newValue)

    }



    const handleChangeAutocompleteSubgudang = (event: SyntheticEvent, newValue: any | null) => {

        setValue('mmgudang_sub_id', newValue?.id)

        setValSubgudang(newValue)

    }





    return (

        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>

            <Grid item xl={12} md={12} xs={12}>

                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>

                    <Icon icon='mdi:arrow-left' />

                    Kembali

                </Fab>

                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>

                    <Typography variant='h5' sx={{ textAlign: 'center' }}>

                        Detail Good Receipt

                    </Typography>

                    <Typography variant='body1' sx={{ textAlign: 'center' }}>

                        No. Dokumen : <b>{id}</b>

                    </Typography>

                    <Divider sx={{ m: 0 }} />

                    <form onSubmit={handleSubmit(onSubmit)}>

                        <Grid container spacing={3}>

                            <Grid item xs={12} md={6}>

                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>

                                    Document Tag

                                </Typography>

                                <FormControl fullWidth>

                                    <Controller

                                        name='sysdoctag_id'

                                        control={control}

                                        rules={{ required: true }}

                                        render={({ field: { value, onChange } }) => (

                                            <Autocomplete

                                                value={valDoctag}

                                                options={listDoctag}

                                                id='sysdoctag_id'

                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}

                                                onChange={handleChangeAutocompleteDoctag}

                                                renderOption={(props: any, option: any) => {

                                                    return (

                                                        <li {...props} key={option.id}>

                                                            {option.nama}

                                                        </li>

                                                    )

                                                }}

                                                getOptionLabel={(option: any) => option.nama}

                                                renderInput={(params: any) => (

                                                    <TextField

                                                        {...params}

                                                        label='Document Tag'

                                                        error={Boolean(errors.sysdoctag_id)}

                                                        InputLabelProps={{ shrink: true }}

                                                    />

                                                )}

                                            />

                                        )}

                                    />

                                    {errors.sysdoctag_id && (

                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>

                                    )}

                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={6}>

                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>

                                    Tanggal

                                </Typography>

                                <FormControl fullWidth>

                                    <Controller

                                        name='tgl'

                                        control={control}

                                        rules={{ required: true }}

                                        render={({ field: { value, onChange } }) => (

                                            <TextField

                                                label='Tanggal'

                                                type='date'

                                                error={Boolean(errors.tgl)}

                                                onChange={onChange}

                                                value={value}

                                                InputLabelProps={{ shrink: true }}

                                            />

                                        )}

                                    />

                                    {errors.tgl && (

                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>

                                    )}

                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={6}>

                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>

                                    Surat Jalan

                                </Typography>

                                <FormControl fullWidth>

                                    <Controller

                                        name='nomor_sj'

                                        control={control}

                                        rules={{ required: true }}

                                        render={({ field: { value, onChange } }) => (

                                            <TextField

                                                label='Surat Jalan'

                                                error={Boolean(errors.nomor_sj)}

                                                onChange={onChange}

                                                value={value}

                                                InputLabelProps={{ shrink: true }}

                                            />

                                        )}

                                    />

                                    {errors.nomor_sj && (

                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>

                                    )}

                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={6}>

                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>

                                    Tanggal Kirim

                                </Typography>

                                <FormControl fullWidth>

                                    <Controller

                                        name='tgl_kirim'

                                        control={control}

                                        rules={{ required: true }}

                                        render={({ field: { value, onChange } }) => (

                                            <TextField

                                                label='Tanggal Kirim'

                                                type='date'

                                                error={Boolean(errors.tgl_kirim)}

                                                onChange={onChange}

                                                value={value}

                                                InputLabelProps={{ shrink: true }}

                                            />

                                        )}

                                    />

                                    {errors.tgl_kirim && (

                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>

                                    )}

                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={6}>

                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>

                                    Transportasi

                                </Typography>

                                <FormControl fullWidth>

                                    <Controller

                                        name='transportasi'

                                        control={control}

                                        rules={{ required: true }}

                                        render={({ field: { value, onChange } }) => (

                                            <TextField

                                                label='Transportasi'

                                                error={Boolean(errors.transportasi)}

                                                onChange={onChange}

                                                value={value}

                                                InputLabelProps={{ shrink: true }}

                                            />

                                        )}

                                    />

                                    {errors.transportasi && (

                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>

                                    )}

                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={6}>

                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>

                                    Kurir

                                </Typography>

                                <FormControl fullWidth>

                                    <Controller

                                        name='kurir'

                                        control={control}

                                        rules={{ required: true }}

                                        render={({ field: { value, onChange } }) => (

                                            <TextField

                                                label='Kurir'

                                                error={Boolean(errors.kurir)}

                                                onChange={onChange}

                                                value={value}

                                                InputLabelProps={{ shrink: true }}

                                            />

                                        )}

                                    />

                                    {errors.kurir && (

                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>

                                    )}

                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={6}>

                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>

                                    Gudang

                                </Typography>

                                <FormControl fullWidth>

                                    <Controller

                                        name='mmgudang_id'

                                        control={control}

                                        rules={{ required: false }}

                                        render={({ field: { value, onChange } }) => (

                                            <Autocomplete

                                                value={valGudang}

                                                options={listGudang}

                                                id='mmgudang_id'

                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}

                                                onChange={handleChangeAutocompleteGudang}

                                                renderOption={(props: any, option: any) => {

                                                    return (

                                                        <li {...props} key={option.id}>

                                                            {option.nama}

                                                        </li>

                                                    )

                                                }}

                                                getOptionLabel={(option: any) => option.nama}

                                                renderInput={(params: any) => (

                                                    <TextField

                                                        {...params}

                                                        label='Gudang'

                                                        error={Boolean(errors.mmgudang_id)}

                                                        InputLabelProps={{ shrink: true }}

                                                    />

                                                )}

                                            />

                                        )}

                                    />

                                    {errors.mmgudang_id && (

                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>

                                    )}

                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={6}>

                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>

                                    Sub Gudang

                                </Typography>

                                <FormControl fullWidth>

                                    <Controller

                                        name='mmgudang_sub_id'

                                        control={control}

                                        rules={{ required: false }}

                                        render={({ field: { value, onChange } }) => (

                                            <Autocomplete

                                                value={valSubgudang}

                                                options={listSubgudang}

                                                id='mmgudang_sub_id'

                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}

                                                onChange={handleChangeAutocompleteSubgudang}

                                                renderOption={(props: any, option: any) => {

                                                    return (

                                                        <li {...props} key={option.id}>

                                                            {option.nama}

                                                        </li>

                                                    )

                                                }}

                                                getOptionLabel={(option: any) => option.nama}

                                                renderInput={(params: any) => (

                                                    <TextField

                                                        {...params}

                                                        label='Sub Gudang'

                                                        error={Boolean(errors.mmgudang_sub_id)}

                                                        InputLabelProps={{ shrink: true }}

                                                    />

                                                )}

                                            />

                                        )}

                                    />

                                    {errors.mmgudang_sub_id && (

                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>

                                    )}

                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={6} hidden>

                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>

                                    Total

                                </Typography>

                                <FormControl fullWidth>

                                    <Controller

                                        name='total'

                                        control={control}

                                        rules={{ required: false }}

                                        render={({ field: { value, onChange } }) => (

                                            <TextField

                                                label='Total'

                                                error={Boolean(errors.total)}

                                                onChange={onChange}

                                                value={value}

                                                type='number'

                                                inputProps={{ readOnly: true }}

                                                InputLabelProps={{ shrink: true }}

                                            />

                                        )}

                                    />

                                    {errors.total && (

                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>

                                    )}

                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={12}>

                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>

                                    Keterangan

                                </Typography>

                                <FormControl fullWidth>

                                    <Controller

                                        name='keterangan'

                                        control={control}

                                        rules={{ required: false }}

                                        render={({ field: { value, onChange } }) => (

                                            <TextField

                                                label='Keterangan'

                                                error={Boolean(errors.keterangan)}

                                                onChange={onChange}

                                                multiline

                                                rows={3}

                                                value={value}

                                                InputLabelProps={{ shrink: true }}

                                            />

                                        )}

                                    />

                                    {errors.keterangan && (

                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>

                                    )}

                                </FormControl>

                            </Grid>

                            <Grid item xs={12} sm={12}>

                                <Box

                                    sx={{

                                        width: '100%',

                                        display: 'flex',

                                        flexWrap: 'wrap',

                                        alignItems: 'center',

                                        justifyContent: 'center'

                                    }}

                                >

                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>

                                        <Button variant='contained' type='submit'

                                        >

                                            SIMPAN

                                        </Button>

                                    </Box>

                                </Box>

                            </Grid>

                            <Grid item xs={12} sm={12}>

                                <MsiDatagrid array={listDetail} hiddenColumns={[

                                    'id', 'deleted_at', 'konversi', 'tgl_kebutuhan', 'pbgr_d_id', 'pbgr_id', 'mmbarang_id', 'created_at', 'created_by',

                                    'updated_at', 'updated_by', 'valas', 'keterangan', 'kode_barang', 'jenis_barang'

                                ]}

                                    customRender={customRender}

                                />

                            </Grid>



                        </Grid>

                    </form>

                </div>

            </Grid>

            <Dialog

                maxWidth={'xs'}

                fullWidth={true}

                open={openDialog}

                onClose={handleCloseDialog}

            >

                <DialogTitle>

                    <Typography variant='body1' sx={{ fontWeight: 500, my: 1.5, color: '#212121' }}>

                        Edit Qty Barang

                    </Typography>

                </DialogTitle>

                <DialogContent sx={{ pt: 1 }}>

                    <Typography variant='body1' sx={{ fontWeight: 500, my: 1.5, color: '#212121' }}>

                        Qty Lama : {qty}

                    </Typography>

                    <TextField
                        sx={{ my: 2 }}
                        fullWidth
                        label='Qty Baru'
                        type='number'
                        value={editQty ?? ''}
                        autoFocus
                        inputProps={{ min: 0.01, step: 0.01 }}
                        onChange={e => setEditQty(e.target.value)}
                        helperText='Total GR akan dihitung ulang oleh server berdasarkan harga snapshot PO.'
                        InputLabelProps={{ shrink: true }}

                        onKeyDown={(e) => {

                            // cadangan: jika pengguna tekan Enter di field, submit juga

                            if (e.key === 'Enter') {

                                e.preventDefault()

                                handleSaveQty()

                            }

                        }}

                    />

                </DialogContent>

                <DialogActions>

                    <Button onClick={handleCloseDialog} color='inherit'>

                        Batal

                    </Button>

                    <Button onClick={handleSaveQty} variant='contained' color='primary'>

                        Simpan

                    </Button>

                </DialogActions>

            </Dialog>



            <FloatingJurnalButton

                id={Number(id)}

                tabel="pbgr"

            />



            <AttachmentFab

                docId={Number(id)}

                docType="pbgr"

            />

        </Grid>

    )

}